import React, { createContext, useState, useEffect } from "react";
import Fuse from "fuse.js";
import axios from "axios";

const CartContext = createContext();
export default CartContext;

export function CartProvider({ children }) {
  const [storeId, SetStoreId] = useState(
    // "02722210-C6F8-43C2-869C-AF979F4B7C79" //DEV
    "382ece18-fc96-4258-9fb0-413c3f950ccb"
  );

  const LicenseType = {
    FREE: 0,
    BASIC: 1,
    STANDARD: 2,
    PROFESSIONAL: 3,
    ENTERPRISE: 4,
    PREMIUM: 5,
    CUSTOM: 6,
  };

  const ProductType = {
    Retail_POS: 1,
    Restaurant_POS: 2,
    ECommerce: 3,
    KIOSK_ECommerce: 6,
    QRCODE_ECommerce: 7,
    ERP: 10,
    SupplyChain: 11,
    WarehouseManagement: 12,
    ProductionManagement: 13,
    CRM: 15,
    HRM: 16,
    Finance: 17,
    WebSite: 18,
  };

  const [EcSettings, setEcSettings] = useState([]);

  // const [storeSettings, setStoreSettings] = useState({
  //   loginMethod: "EMAIL",
  //   liveMode: true,
  //   phoneNumberLength: 10,
  //   pincodeLength: "6",
  //   defaultCountry: "en-IN",
  //   defaultCurrency: "INR",
  //   SeoCost: 2500,
  //   defaultState: "KA",
  //   //test
  //   // razorpayKey: "rzp_test_J8eDV3MtSXcY0G",
  //   // razorpayKeySecret: "9rJL8CeULq5OsPggS8hGX12A",
  //   //live
  //   razorpayKey: "rzp_live_VjyM1TewqWgvnS",
  //   razorpayKeySecret: "YC6oX1NCIuIykWQbHZ05nw1P",

  //   razorpayCurrency: "INR",
  //   razorpayCompanyName: "SANTREZA IT Solutions P Limited",
  //   razorpayCompanyDescription: "Software Company",
  //   razorpayCompanyAddress:
  //     "230 Kammasandra, Electronic City, Bangalore-560100",
  //   razorpayThemeColor: "green",
  //   StorageBlobImageUrl:
  //     "https://ecprdstorage01.blob.core.windows.net/elasticcart/images/",
  //   storageBlobInvoiceUrl:
  //     "https://ecprdstorage01.blob.core.windows.net/elasticcart/invoice/",
  //   dataRententionFreeDays: 5,
  //   dataRententionOneYear: 249,
  //   dataRentention2Years: 499,
  //   dataRentention3Years: 749,
  //   dataRentention5Years: 1499,
  //   taxPercentage: 18,
  //   seoCost: 2500,
  // });

  const [storeStatusTypes, setStoreStatusTypes] = useState([]);
  const [storeTypes, setStoreTypes] = useState([]);
  const [businessCategories, setBusinessCategories] = useState([]);
  const [businessTypes, setBusinessTypes] = useState([]);

  const [orderData, setOrderData] = useState([]);
  const [prods, SetProds] = useState([]);
  const [showUserLoginNew, setShowUserLoginNew] = useState(false);
  // const [loginMethod, setLoginMethod] = useState("SMS");
  const [productTypes, setProductTypes] = useState([]);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    storeId: "",
    emailId: "",
    mobileNo: "",
    bearerToken: "",
    loginStatus: "inactive", //active/inactive
    hideSignupLink: "", //set "true" for hide; set "" for show
  });
  const [selectedProduct, setSelectedProduct] = useState(false);

  const SetSelectedProduct = (product) => {
    setSelectedProduct(product);
  };

  const [OrderStatus, setOrderStatus] = useState("");
  const UpdateOrderStatus = (status) => {
    setOrderStatus(status);
  };

  const GetEcSettingValueByName = (name) => {
    if (EcSettings != undefined && EcSettings.length > 0) {
      var result = EcSettings.filter((f) => f.name == name);
      if (result.length > 0) return result[0].value;
      else return "";
    }
    return "";
  };

  const GetEcSettings = () => {
    fetch(process.env.REACT_APP_API + "Sales/GetEcSettings/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          setEcSettings(data);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const GetAllProducts = () => {
    fetch(process.env.REACT_APP_API + "Sales/GetECProducts/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          SetProds(data.filter((f) => f.showMe == true));
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const ShowUserLoginNew = (status) => {
    setShowUserLoginNew(status);
  };

  const storeUserData = (data) => {
    console.log(data.bearerToken);
    setUserData({
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      contactNo: data.contactNo,
      emailId: data.emailId,
      address: data.address,
      city: data.city,
      state: data.state,
      country: data.country,
      bearerToken: data.bearerToken,
      loginStatus: "active",
      hideSignupLink: "true", //set "true" for hide; set "" for show
    });
    setUserData((state) => {
      //todo: enable
      localStorage.setItem("localstorageUserData", JSON.stringify(state));
      return state;
    });
  };

  const clearUserData = () => {
    setUserData({
      firstName: "",
      lastName: "",
      emailId: "",
      password: "",
      mobileNo: "",
      bearerToken: "",
      loginStatus: "inactive",
      hideSignupLink: "", //set "true" for hide; set "" for show
    });

    //this is a callback. store the cart in local store
    setUserData((state) => {
      //todo: enable
      localStorage.setItem("localstorageUserData", JSON.stringify(state));
      return state;
    });
  };

  const RefreshBearerTokenWithMobileNoOrEmailId = (userData) => {
    if (userData !== "" && userData.loginStatus !== "active") {
      ShowUserLoginNew(true);
      return;
    }
    if (
      userData !== "" &&
      userData.loginStatus === "active" &&
      userData.id === undefined
    ) {
      ShowUserLoginNew(true);
      return;
    }

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "Sales/LoginTenant/" +
        userData.contactNo +
        "/" +
        userData.emailId,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404) {
          clearUserData();
          return;
        }
        storeUserData(data);
        console.log("storeUserData(data) success");
      })
      .catch((error) => {
        console.error("RefreshBearerToken: There was an error!", error);
        alert("RefreshBearerToken err:" + error);
      });
  };

  useEffect(() => {
    var v1 = localStorage.getItem("localstorageUserData");
    if (v1 !== null && v1 !== `""` && v1 !== ``) {
      {
        setUserData(JSON.parse(v1));
      }

      //re-login when portal is open
      setUserData((state) => {
        if (
          (state.contactNo != "" && state.contactNo != undefined) ||
          (state.emailId != "" && state.emailId != undefined)
        ) {
          //if (state.emailId != "") {
          // ValidateLogin(state.emailId, state.password, state.storeId);
          RefreshBearerTokenWithMobileNoOrEmailId(state);
          // ValidateLogin(state.mobileNo, state.emailId, state.storeId);
        }
        return state;
      });
    }
  }, []);

  const ClearAllCookies = () => {
    //1. clear Cart Items
    localStorage.setItem("localstoragecartitems", null);
  };
  const StoreMyIpAddress = () => {
    fetch("https://api.ipify.org/?format=json")
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        //this.setState({ myClientIpAddress: data.IPv4 });
        var res = axios
          .post(
            process.env.REACT_APP_API +
              "Consumers/StoreClientIpaddress/" +
              storeId +
              "/" +
              data.ip
          )
          .then((response) => {
            if (response.status === 200) {
            }
          })
          .catch((error) => {
            console.log("StoreMyIpAddress error");
          });
      })
      .catch((error) => console.log(error));
  };

  const storeOrderInformation = (data) => {
    setOrderData(data);
  };

  const GetTicks = (date) => {
    var currentTime = date.getTime();
    // 10,000 ticks in 1 millisecond
    // jsTicks is number of ticks from midnight Jan 1, 1970
    var jsTicks = currentTime * 10000;
    // add 621355968000000000 to jsTicks
    // netTicks is number of ticks from midnight Jan 1, 01 CE
    var netTicks = jsTicks + 621355968000000000;
    return netTicks;
  };

  const GetInDateFormat = (D) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = D.getDate();

    const monthIndex = D.getMonth();
    const monthName = monthNames[monthIndex];

    const year = D.getFullYear();

    return `${day}-${monthName}-${year}`;
  };
  const GetStoreStatusTypes = () => {
    fetch(process.env.REACT_APP_API + "Common/GetStoreStatusTypes/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setStoreStatusTypes(data);
      })
      .catch((error) => {
        alert("GetStoreTypes Error:: " + error);
      });
  };
  const GetStoreTypes = () => {
    fetch(process.env.REACT_APP_API + "Common/GetStoreTypes/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setStoreTypes(data);
      })
      .catch((error) => {
        alert("GetStoreTypes Error:: " + error);
      });
  };
  const GetBusinessTypes = () => {
    fetch(process.env.REACT_APP_API + "Common/GetBusinessTypes/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setBusinessTypes(data);
      })
      .catch((error) => {
        alert("GetBusinessTypes Error:: " + error);
      });
  };
  const GetBusinessCategories = () => {
    fetch(process.env.REACT_APP_API + "Common/GetBusinessCategories/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setBusinessCategories(data);
      })
      .catch((error) => {
        alert("GetBusinessTypes Error:: " + error);
      });
  };

  const HandleTryNowButtonClick = (productType) => {
    var v1 = localStorage.getItem("localstorageUserData");
    if (v1 !== null && v1 !== `""` && v1 !== ``) {
      setUserData(JSON.parse(v1));
    }
    var userData = JSON.parse(v1);
    if (userData && userData.loginStatus == "active") {
      const product = prods.find((f) => f.productType === productType);
      if (product != undefined) {
        SetSelectedProduct(product);
      }
    } else ShowUserLoginNew(true);
  };

  const GetProductByType = (productType) => {
    if (prods != undefined) {
      const product = prods.find((f) => f.productType === productType);
      if (product != undefined) return product;
    }
    return { name: "" };
  };

  const GetLicenseTypeNameById = (id) => {
    var result = storeTypes.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };
  const GetProductTypeNameById = (id) => {
    var result = productTypes.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };

  const IsECommerceProduct = (productTypeId) => {
    if (
      productTypeId == ProductType.ECommerce ||
      productTypeId == ProductType.ECommerce_B2C_Restaurant ||
      productTypeId == ProductType.CRM ||
      productTypeId == ProductType.ERP ||
      productTypeId == ProductType.SupplyChain
    )
      return true;
    return false;
  };

  const GetPriceOfSelectedProductByLicenseType = (LicenseTypeId) => {
    if (selectedProduct == undefined) return 0;

    var productTypeID = "";
    if (selectedProduct.productTypeId == undefined) {
      productTypeID = selectedProduct.productType;
    } else {
      productTypeID = selectedProduct.productTypeId;
    }

    var result = prods.filter((f) => f.productType == productTypeID);

    if (LicenseTypeId == LicenseType.FREE) return 0;
    if (LicenseTypeId == LicenseType.STANDARD) {
      return (
        result[0].monthlyCost +
        Number(GetEcSettingValueByName("dataRententionOneYear"))
      );
    }
    if (LicenseTypeId == LicenseType.PROFESSIONAL) {
      var additionalusercost = 2 * result[0].additionalUserPrice;
      return (
        result[0].monthlyCost +
        Number(GetEcSettingValueByName("dataRentention2Years")) +
        additionalusercost
      );
    }
    if (
      IsECommerceProduct(selectedProduct.productTypeId) &&
      LicenseTypeId == LicenseType.PREMIUM
    ) {
      var additionalusercost = 4 * result[0].additionalUserPrice;
      return (
        result[0].monthlyCost +
        Number(GetEcSettingValueByName("dataRentention3Years")) +
        additionalusercost +
        Number(GetEcSettingValueByName("SeoCost"))
      );
    }
    if (LicenseTypeId == LicenseType.PREMIUM) {
      var seoCost = 0;
      var additionalusercost = 4 * result[0].additionalUserPrice;

      if (IsECommerceProduct(selectedProduct.productType) == true) {
        seoCost = Number(GetEcSettingValueByName("SeoCost"));
      }
      return (
        result[0].monthlyCost +
        Number(GetEcSettingValueByName("dataRentention3Years")) +
        additionalusercost +
        seoCost
      );
    }
    return "NA";
  };

  const GetMonthlyCostOfStore = (store) => {
    if (store.storeTypeId == LicenseType.FREE) {
      return 0;
    } else {
      var totUsers = 0;
      var dataRetentionCost = 0;
      var enableSEO = false;
      if (store.storeTypeId == LicenseType.STANDARD) {
        totUsers = 1;
        dataRetentionCost = Number(
          GetEcSettingValueByName("dataRententionOneYear")
        );
        enableSEO = false;
      } else if (store.storeTypeId == LicenseType.PROFESSIONAL) {
        totUsers = 3;
        dataRetentionCost = Number(
          GetEcSettingValueByName("dataRentention2Years")
        );
        enableSEO = false;
      } else if (store.storeTypeId == LicenseType.PREMIUM) {
        totUsers = 5;
        dataRetentionCost = Number(
          GetEcSettingValueByName("dataRentention3Years")
        );
        enableSEO = false;
        if (IsECommerceProduct(store.productTypeId)) enableSEO = true;
      } else if (store.storeTypeId == LicenseType.CUSTOM) {
        totUsers = store.totalUsers;
        dataRetentionCost = store.dataRetensionMonthlyCost;
        enableSEO = store.enableSeo;
      }

      var tot =
        Number(store.monthlyCost) +
        (totUsers - 1) * store.additionalUserCost +
        Number(dataRetentionCost);
      if (enableSEO == true) {
        tot += Number(GetEcSettingValueByName("SeoCost"));
      }
      return tot;
    }
  };

  const GetEcProductTypes = () => {
    fetch(process.env.REACT_APP_API + "Sales/GetEcProductTypes")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else setProductTypes(data);
      })
      .catch((error) => {});
  };

  return (
    <CartContext.Provider
      value={{
        storeId,
        EcSettings,
        prods,
        ProductType,
        selectedProduct,
        userData,
        showUserLoginNew,
        OrderStatus,
        orderData,
        businessTypes,
        storeTypes,
        storeStatusTypes,
        businessCategories,
        LicenseType,
        productTypes,
        GetStoreTypes,
        StoreMyIpAddress,
        ShowUserLoginNew,
        storeUserData,
        clearUserData,
        RefreshBearerTokenWithMobileNoOrEmailId,
        GetAllProducts,
        SetSelectedProduct,
        UpdateOrderStatus,
        storeOrderInformation,
        GetInDateFormat,
        GetBusinessTypes,
        GetStoreStatusTypes,
        GetBusinessCategories,
        IsECommerceProduct,
        HandleTryNowButtonClick,
        GetLicenseTypeNameById,
        GetTicks,
        GetMonthlyCostOfStore,
        GetPriceOfSelectedProductByLicenseType,
        GetProductByType,
        GetEcProductTypes,
        GetProductTypeNameById,
        GetEcSettings,
        GetEcSettingValueByName,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
